<app-workflow-step-layout [readOnly]="true">
  <ng-container info>
    <div class="container">
      <h3 style="grid-column: span 2; margin-bottom: 1.5rem;">Zusammenfassung</h3>

      <div class="metadata-container">
        <div class="metadata-row">
          <span class="label">Abgeschlossen am:</span>
          <span class="value">{{ workFlowStep?.finishedAt | date: globals.dateTimeFormat }}</span>
        </div>

        <div class="metadata-row">
          <span class="label">Abgeschossen von:</span>
          <span class="value">{{ workFlowStep?.finishedBy }}</span>
        </div>

        <ng-container
          *ngIf="workflowDetailClientService.workflowInstance.isLibrary() && workflowDetailClientService.workflowInstance.approvedBy">
          <div class="metadata-row">
            <span class="label">Freigegeben am:</span>
            <span
              class="value">{{ workflowDetailClientService.workflowInstance.approvedAt | date: globals.dateTimeFormat }}</span>
          </div>

          <div class="metadata-row">
            <span class="label">Freigegeben von:</span>
            <span class="value">{{ workflowDetailClientService.workflowInstance.approvedBy }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="!workflowDetailClientService.workflowInstance.isLibrary()">
          <div class="metadata-row">
            <span class="label">Für Library Freigegeben:</span>
            <span class="value">{{ workFlowStep?.workflowInstance.sharedToLibrary ? 'Ja' : 'Nein' }}</span>
          </div>

          <div class="metadata-row">
            <span class="label">Verwendet in Library:</span>
            <span class="value"
                  [ngClass]="usedInLibrary ? 'library-link' : ''"
                  (click)="navigateToLibrary()">
              {{ usedInLibrary?.workflowNumber || '---' }}
            </span>
          </div>
        </ng-container>

        <div style="margin-top: 2rem; display: flex; justify-content: center; gap: 1rem;">

          <core-button
            (onClick)="downloadFullWorkflowPdf()"
            [icon]="faFilePdf"
            text="PDF Generieren (Live)">
          </core-button>

          <core-button
            *ngIf="workFlowStep?.file"
            (onClick)="downloadStoredPdf()"
            [icon]="faDownload"
            text="Zusammenfassung herunterladen">
          </core-button>

        </div>

      </div>
    </div>
  </ng-container>
  <ng-container plate>

    <div class="comments-overview" *ngIf="workflowDetailClientService?.workflowInstance?.steps?.length">
      <h3>Kommentare im Workflow</h3>
      <div class="comments-table">
        <div class="table-header">
          <div class="col-step">Schritt</div>
          <div class="col-comment">Kommentar</div>
          <div class="col-action"></div>
        </div>
        <ng-container *ngFor="let s of uniqueLatestSteps">
          <div class="table-row">
            <div class="col-step">{{ s.step | workflowStepReadable }}</div>
            <div class="col-comment">
              <span *ngIf="hasNonEmptyComment(s.comment?.comment); else noComment">
                {{ isExpanded(s.id) ? s.comment.comment : commentStripped(s.comment.comment, 60) }}
              </span>
              <ng-template #noComment>
                <span class="no-comment-text">---</span>
              </ng-template>
            </div>
            <div class="col-action">
              <button
                *ngIf="hasNonEmptyComment(s.comment?.comment) && s.comment.comment.length > 60"
                pButton
                type="button"
                [icon]="isExpanded(s.id) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                class="p-button-rounded p-button-text p-button-sm"
                (click)="toggleExpanded(s.id)">
              </button>
              <i class="pi pi-info-circle info-icon"
                 *ngIf="hasNonEmptyComment(s.comment?.comment) && s.comment?.commentCreated"
                 [pTooltip]="'Erstellt: ' + (s.comment.commentCreated | date: 'dd.MM.yyyy HH:mm') + '\nVon: ' + s.comment.commentCreatedBy"
                 tooltipPosition="top">
              </i>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</app-workflow-step-layout>
